import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
  inject,
  input,
  TemplateRef,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ResultGroup, ResultRating } from '@core/interview-results-types';
import type { Placement } from '@core/placements-types';
import { HiddenEvaluationsInfoboxComponent } from '@core/unbiased-hiring-legacy';
import { TruncateComponent } from '@core/user-interface-legacy';

import { OverallItemRowComponent } from './overall-item-row/overall-item-row.component';

@Component({
  selector: 'rt-interview-result-summary-overall-item',
  templateUrl: 'interview-result-summary-overall-item.component.html',
  styleUrls: ['./interview-result-summary-overall-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TruncateComponent,
    OverallItemRowComponent,
    TranslatePipe,
    HiddenEvaluationsInfoboxComponent,
    NgTemplateOutlet,
  ],
})
export class InterviewResultSummaryOverallItemComponent {
  private readonly store = inject(Store);

  public readonly hasMultiplePlacements = input<boolean>(undefined!);
  public readonly currentUserAvailablePlacements = input<Placement[]>([]);
  public readonly hasAccessToAllJobOffers = input<boolean>();
  public readonly hiddenEvaluationsInfoboxTpl = input<TemplateRef<unknown>>();
  @Input() public group: ResultGroup;

  public counterClick = output();

  public totalRatingsCount: number;

  public ngOnInit(): void {
    this.totalRatingsCount = this.getTotalRatingsCount().reduce((acc, value) => acc + value);
  }

  public hasAccessToJob(offerId: number): boolean {
    return (
      this.hasAccessToAllJobOffers() ||
      this.currentUserAvailablePlacements().some(placement => placement.offerId === offerId)
    );
  }

  public trackBy(index: number, item: ResultRating): string {
    return item.rating + index;
  }

  public onCounterClick() {
    this.counterClick.emit();
  }

  private getTotalRatingsCount(): number[] {
    return [...this.group.ratings, this.group.hiddenRatings].map(rating => rating?.count || 0);
  }
}
